/**
 * Authentication Utilities
 * Common helper functions for authentication
 */

import { authService } from '../services/auth/authService';

/**
 * Get authorization headers for API requests
 * Works for both local and Cognito authentication modes
 */
export async function getAuthHeaders(): Promise<Record<string, string>> {
  const token = await authService.getToken();
  const headers: Record<string, string> = {};

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return headers;
}

/**
 * Get auth token
 * Works for both local and Cognito authentication modes
 */
export async function getAuthToken(): Promise<string | null> {
  return authService.getToken();
}
